<template>
  <v-container id="docForm" class="max-width">
    <!-- first card -->
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>{{ docTitle }} Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text @click="generateRequisition" color="accent">
          <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate LPO (With Prices)
        </v-btn>

        <v-btn text @click="generateLpoNoPrices" color="accent">
          <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate LPO (Without Prices)
        </v-btn>
        <v-btn small text :to="backUrl">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12" md="7">
                <span class="style-16" style="font-weight: bold">Order Details</span>
                <br />
                <br />
                <span class="style-16">Supplier: {{ record.supplier && record.supplier.Name }}</span>
                <br />

                <span class="style-16">RefNo: {{ record.RefNo }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="4">
            <v-row dense class="pa-1">
              <v-col cols="6" class="py-2 font-weight-medium" style="font-size: 1.2em;">Sub Total:</v-col>
              <v-col cols="6" class="py-2 font-weight-medium" style="font-size: 1.2em;">{{ record.DocTotal &&
                record.DocTotal.toLocaleString() }}.00</v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4">
            <v-row class="justify-end">
              <v-col cols="12" md="7">

                <br />
                <span class="style-16" style="float: right">{{ noTitle }}#: {{ record.DocNum }}</span>
                <br />
                <br />
                <span class="style-16" style="float: right">Date: {{ record.CreatedAt | date }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of first card -->

    <!-- no bp card -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-data-table light dense :items-per-page="1000" :headers="headers" :items="orderItems" item-key="LineNum"
              hide-default-footer disable-sort :mobile-breakpoint="0">
              <template v-slot:item.index="{ index }">
                <span>{{ index + 1 }}</span>
              </template>

              <template v-slot:item.Name="{ item }">
                <!-- autocomplete -->
                <v-text-field style="width: 350px" single-line dense readonly v-model="item.Name"></v-text-field>
              </template>

              <template v-slot:item.UomEntry="{ item }">
                <v-text-field filled outlined readonly dense value="Unit(s)"
                  v-if="item.ManualStatus == 'Y'"></v-text-field>

                <span v-else>Uom Unit</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span>{{ item.Price.toLocaleString() }}.00</span>
              </template>

              <template v-slot:item.QuantityRemaining="{ item }">
                {{ item.QuantityRemaining }}
              </template>

              <template v-slot:item.QtyToReceive="{ item }">
                <v-text-field type="number" outlined v-model="item.QtyToReceive" style="width: 100px"></v-text-field>
              </template>


              <template v-slot:item.PendingQuantity="{ item }">{{ item.Quantity - (parseFloat(item.QuantityDelivered) +
                parseFloat(item.QuantityRemaining)) }}</template>

              <template v-slot:item.LineTotal="{ item }">
                <span>{{ item.DisplayTotal }}.00</span>
              </template>

              <template v-slot:item.edit="{ item }">
                <v-btn icon @click="openEditModal(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.delete="{ item }">
                <v-btn icon color="red" @click="openDeleteModal(item)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of card -->

    <!-- third card -->
    <v-row class="mt-2 mb-2 subtitle-2 text--primary">
      <v-col cols="12" md="8">
        <v-card class="pa-2">
          <v-row>
            <v-col cols="12" style="padding: 10px">
              <div class="mt-2" style="font-weight: semi-bold; font-size: 12px; color: blue">Record Supplier Payments
              </div>

              <v-data-table class="pa-2" dense light :headers="paymentHeaders" :items="accounts" hide-default-footer>
                <template v-slot:item.Name="{ item }">
                  <div style="font-size: 16px; width: 120px">{{ item.Name }}</div>
                </template>
                <template v-slot:item.SumApplied="{ item }">
                  <v-text-field type="number" outlined v-model="item.SumApplied" style="width: 200px"></v-text-field>
                </template>
                <template v-slot:item.PaymentRemarks="{ item }">
                  <v-text-field outlined v-model="item.PaymentRemarks" style="width: 250px"></v-text-field>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <div class="style-18">Total Bill: {{ record.DocTotal | currency }}</div>
              <br />
              <div class="style-18">Balance: {{ balance | currency }}</div>
              <br />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-text style="height: 150px">
            <v-row dense class="pa-1">
              <v-col cols="12">
                <v-autocomplete class="mt-4" name="transferCopyTo" dense outlined v-model="copyObj" :items="copyData"
                  label="Copy To" item-text="Name" item-value="id"></v-autocomplete>
              </v-col>

              <v-col cols="6">
                <v-btn block color="primary" @click="receiveGoods" :loader="loader" :disabled="loader">Receive
                  Goods</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-divider class="mt-2"></v-divider>

    <!-- Editing dialog -->
    <v-dialog v-model="editingDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Edit Purchase Order</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="editingDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>

              <v-col cols="12" xs="12">
                <span style="font-size: 20px; font-weight: bold">{{ editItem.name }}</span>
              </v-col>

              <v-col cols="12" xs="12" md="6">
                <v-text-field autocomplete="off" type="number" v-model="editItem.Quantity" label="Quantity" outlined
                  dense></v-text-field>
              </v-col>

              <v-col cols="12" xs="12" md="6">
                <v-text-field autocomplete="off" type="number" v-model="editItem.Price" label="Price" outlined
                  dense></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" class="float-right" @click="editRecord" :loading="loader">
                  <v-icon left>mdi-pencil</v-icon> Edit Record
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of editing modal-->

    <v-dialog v-model="deleteDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title> Delete Lpo Row </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">
                  <v-col cols="12">
                    Are you sure you want to delete / disable this record ?
                  </v-col>
                  <v-col cols="12">
                    <span style="font-size: 16px; color: red;">{{ selectedItem && selectedItem.name }}</span>
                  </v-col>

                  <v-col cols="4">
                    <span style="font-size: 16px">Quantity: {{ selectedItem && selectedItem.Quantity }}</span>
                  </v-col>

                  <v-col cols="4">
                    <span style="font-size: 16px">Price: {{ selectedItem && selectedItem.Price | currency }}</span>
                  </v-col>

                  <v-col cols="4">
                    <span style="font-size: 16px">Total: {{ selectedItem && selectedItem.LineTotal | currency }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="red" dark :loading="loader" @click="deleteLpoRow">Yes, Delete</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
import { v4 as uuidv4 } from 'uuid';
export default {
  props: {
    docTitle: {
      type: String
    },
    backUrl: {
      type: String
    },
    noTitle: {
      type: String
    },
    initial: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalPayments() {
      let total = 0;
      if (typeof this.accounts != "undefined" && this.accounts.length > 0) {
        return this.accounts
          .map(item => {
            let amount = 0;
            if (item.SumApplied) {
              amount = parseFloat(item.SumApplied);
            }

            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    balance() {
      return this.record.DocTotal - this.totalPayments;
    }
  },
  data: () => ({
    record: {},
    deleteDialog: false,
    selectedItem: {},
    editingDialog: false,
    editItem: {},
    DocNum: null,
    loader: false,
    copyObj: null,
    copyData: [{ Name: "Goods Receipt", id: 12 }],
    orderItems: [],
    accounts: [],
    pageItems: 100,
    headers: [
      { text: "NO:", value: "index" },
      { text: "Product", value: "name" },
      { text: "Qty Ordered", value: "Quantity" },
      { text: "Qty Deliverred", value: "QuantityDelivered" },
      { text: "Qty Remaining", value: "QuantityRemaining" },
      { text: "Qty (To Receive)", value: "QtyToReceive" },
      // { text: "Pending Qty", value: "PendingQuantity" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" }
    ],
    paymentHeaders: [
      { text: "Account", value: "Name" },
      { text: "Amount", value: "SumApplied" },
      { text: "Ref/Code", value: "PaymentRemarks" }
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    generateRequisition() {
      const storeId = this.activeStore;
      var url = `/print-general-lpo/${storeId}/${this.record.id}`;
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    generateLpoNoPrices() {
      const storeId = this.activeStore;
      var url = `/generate-lpo-no-prices/${storeId}/${this.record.id}`;
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    receiveGoods() {
      if (this.copyObj == null || this.copyObj == undefined) {
        this.$refs.snackbar.show("Please select a copy to option", "red");
        return;
      }

      var total = 0;
      // loop order items and create rows
      var orderData = this.orderItems;
      var rows = [];
      for (const row of orderData) {
        var quantity = row.QtyToReceive;

        if (
          quantity == "" ||
          quantity == 0 ||
          quantity == null ||
          quantity == undefined
        ) {
          continue;
        }

        var details = {
          productId: row.productId,
          UomEntry: 0,
          Quantity: parseFloat(row.QtyToReceive),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: parseInt(this.record.storeId)
        };

        var lineTotal =
          parseFloat(row.QtyToReceive) * parseFloat(row.Price);
        total += lineTotal;

        rows.push(details);
      }
      // end

      if (rows.length == 0) {
        this.$refs.snackbar.show("No items to receive", "red");
        return;
      }

      var uniqueId = this.generateUniqueId();

      var data = {
        ObjType: 12,
        UniqueId: uniqueId,
        DocNum: this.DocNum,
        DocDate: new Date().toISOString().substr(0, 10),
        LpoRef: this.record.id,
        DocTotal: total,
        TotalPaid: this.totalPayments,
        Balance: this.balance,
        CardCode: this.record.SupplierId,
        StoreId: parseInt(this.record.storeId),
        StoreID: parseInt(this.record.storeId)
      };

      data.rows = rows;

      // set payments
      let payments = [];
      const accountsData = this.accounts;

      for (const account of accountsData) {
        if (account.SumApplied) {
          let details = {
            accountId: parseInt(account.id),
            Amount: parseFloat(account.SumApplied),
            RefNo: account.PaymentRemarks
          };

          payments.push(details);
        }
      }

      data.payments = payments;

      const url = "/copy-lpo-to-goods-receipt";
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$router.push("/goods-receipt");
          }

          if (res.ResultCode == 1500) {
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });
    },
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    openEditModal(data) {
      this.editItem = data;
      this.editingDialog = true;3
    },
    openDeleteModal(data) {
      this.selectedItem = data;
      this.deleteDialog = true;
    },
    deleteLpoRow() {
      const self = this;
      var id = parseInt(self.selectedItem.id);

      var url = `/delete-lpo-row/${id}`;
      self.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode != 1200) {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }

          if (res.ResultCode == 1200) {
            location.reload();
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    editRecord() {
      const self = this;
      var data = {
        id: parseInt(self.editItem.id),
        Quantity: parseFloat(self.editItem.Quantity),
        Price: parseFloat(self.editItem.Price)
      };

      var url = `/edit-lpo-row`;
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode != 1200) {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          location.reload();
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.getAccounts(), this.getDocNum()]);
  }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>